import { render, staticRenderFns } from "./TextAreaComponent.vue?vue&type=template&id=7e0005fc&scoped=true"
import script from "./TextAreaComponent.vue?vue&type=script&lang=js"
export * from "./TextAreaComponent.vue?vue&type=script&lang=js"
import style0 from "./TextAreaComponent.vue?vue&type=style&index=0&id=7e0005fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0005fc",
  null
  
)

export default component.exports